import { useSession } from "next-auth/react";
import type { Session } from "next-auth";

/**
 * @group Hooks
 * 
 * @summary
 * <blockquote>Hook to get the current client session data.</blockquote>
 * 
 * @returns The current session data or null if not authenticated
 * 
 * @example
 * ```typescript
 * import { useClientSession } from '@shared/ui'
 * 
 * const session = useClientSession();
 * if (session) {
 *   console.log('User:', session.user);
 * }
 * ```
 */
export const useClientSession = (): Session | null => {
  const session = useSession();
  return session.data;
};